module.exports = window["umle.ng.common.http"];